import React from 'react';
import { useAppDispatch } from 'hooks';

import { toggleOption } from '~weekly-planner/reducers/weeklyPlanner';

import { CommonOptions } from './CommonOptions';

interface ComponentProps {
  workerAvailability: boolean;
  viewType: string;
  workerQualifications: boolean;
}

export const WorkerOptions: React.FC<ComponentProps> = ({ workerAvailability, viewType, workerQualifications }) => {
  const dispatch = useAppDispatch();

  const options = [
    {
      id: 'worker-qualifications',
      label: 'Worker Qualifications',
      tooltip: 'Show worker qualification badges on worker cards',
      checked: workerQualifications,
      onChange: () => dispatch(toggleOption({ key: 'workerQualifications', toggle: !workerQualifications })),
    },
    {
      id: 'availability',
      label: 'Availability',
      tooltip: `Display worker availability blocks ${viewType === 'Clients' ? '(Disabled in Client view)' : ''}`,
      checked: workerAvailability,
      disabled: viewType === 'Clients',
      onChange: () => dispatch(toggleOption({ key: 'workerAvailability', toggle: !workerAvailability })),
    },
  ];

  return <CommonOptions title="Control worker information display options" options={options} />;
};
